import React from "react";

import { ListItem, ListItemText } from "@mui/material";

import { SubHeader } from "../../atoms/Typography/SubHeader/SubHeader";
import { NavBarItemClickStyle, NavBarItemstyle } from "./SideNavigation.style";

export const MenuItem = ({
  navigate,
  icon,
  displayText,
  key,
  visibility,
  color,
  isActive,
  onMouseDown,
}) => {
  return (
    <ListItem
      key={key}
      sx={{ display: visibility }}
      style={NavBarItemstyle}
      onMouseDown={onMouseDown}
      onClick={() => {
        navigate();
      }}
    >
      <div
        style={{
          width: "4px",
          height: "24px",
          background: isActive ? "#0062CC" : "#FFF",
        }}
      />
      <ListItemText style={NavBarItemClickStyle}>
        <SubHeader
          gap={"12px"}
          icon={icon}
          color={isActive ? "blue.dark3" : "text.grayDark"}
          text={displayText}
        />
      </ListItemText>
    </ListItem>
  );
};
